module.exports = __webpack_public_path__ + "img/banner-mobile.f7374a70.png";